module.exports = __webpack_public_path__ + "media/images/banner-web-98b12ab6.jpg";